module.exports = __webpack_public_path__ + "img/csm_Ersa-Selective-VERSAEYE-01-900x675_8336aa5341.a1860e65.jpg";